import styled, { createGlobalStyle } from "styled-components";

// The global stylesheet pins MUI tooltips at z-index 81, under any dialog; this timeline opens inside one
// (the vehicle details dialog goes up to 2001), so its tips must sit above it
export const DischargeBreakdownTooltipStyle = createGlobalStyle`
  .MuiTooltip-popper.discharge-breakdown-tooltip {
    z-index: 2100 !important;

    // One line per part of the split, at a size that reads at a glance
    .MuiTooltip-tooltip {
      max-width: 320px;
      font-size: 13px;
      line-height: 1.5;
      white-space: pre-line;
    }
  }
`;

export const Container = styled.div`

  .title {
    display: flex;
    justify-content: space-between;
    font-weight: 300;
    font-size: 1.5rem;

    .date {
      font-size: 1.2rem;
    }
  }
  .vertical-timeline {
    padding-bottom: 0;
    padding-top: 0.5em;

    ::before {
      height: calc(100% - 110px);
      top: 22px;
    }

    .vertical-timeline-element {
      margin: 10px 0;

      .vertical-timeline-element-date {
        padding-bottom: 0;
        font-size: 0.8rem;
      }
      .vertical-timeline-element-icon {
        box-shadow: none;

        svg {
          margin-top: -15px;
          width: 40px;
          height: auto;
          position: initial;
          margin-left: auto;
        }
        div:first-child {
          position: relative;
          top: 50%;
        }
      }
      .vertical-timeline-element-content {

        .vertical-timeline-element-date {
          display: none;
        }
        .duration-title {
          font-weight: 300;
          font-size: 1.2rem;
        }
        .block {

          .content {
            padding: 0;
            display: flex;
            justify-content: space-between;
          }
        }
        .flex {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .text {
            display: flex;
            font-weight: bold;
            align-items: center;
            padding-left: 15px;

            svg {
              padding-left: 5px;
            }
          }
        }
      }
    }
  }
  .vertical-timeline::before {
    background: #DDDDDD !important;
  }

  // Sub-item hanging from the "Descarregando" card: how its time splits between unloading and idleness
  .discharge-breakdown {
    position: relative;
    margin: -4px 0 12px 60px;
    padding-left: 26px;

    // Line from the card down to the dot
    ::before {
      content: "";
      position: absolute;
      left: 9px;
      top: 0;
      height: 18px;
      width: 2px;
      background: #BDBDBD;
    }

    .discharge-breakdown-dot {
      position: absolute;
      left: 4px;
      top: 16px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #616161;
      box-shadow: 0 0 0 2px #FFFFFF;
      // Same entrance as the state icons (keyframes from react-vertical-timeline-component)
      animation: cd-bounce-1 0.6s;
    }

    .discharge-breakdown-content {
      // Same entrance as the state cards: from the left, and from the right on narrow screens
      animation: cd-bounce-2 0.6s;

      @media only screen and (max-width: 1169px) {
        animation: cd-bounce-2-inverse 0.6s;
      }

      margin-top: 8px;
      padding: 8px 10px;
      border-radius: 4px;
      background: rgb(221 221 221 / 45%);
      font-size: 0.85rem;
    }

    .discharge-breakdown-title {
      display: flex;
      align-items: center;
      font-weight: 600;
      margin-bottom: 6px;

      .discharge-breakdown-help {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        color: #757575;
        cursor: help;
      }
    }

    .discharge-breakdown-bar {
      display: flex;
      height: 8px;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 6px;
      background: #EEEEEE;
    }

    .discharge-breakdown-row {
      display: flex;
      align-items: center;
      line-height: 1.6;

      .label {
        flex: 1;
      }

      .value {
        font-weight: bold;
        padding-left: 8px;
        white-space: nowrap;
      }
    }

    .swatch {
      flex-shrink: 0;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      margin-right: 6px;
    }

    .unloading {
      background: #616161;
    }

    .idle {
      background: repeating-linear-gradient(45deg, #BDBDBD, #BDBDBD 3px, #D6D6D6 3px, #D6D6D6 6px);
    }
  }
`;
